function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useField, useFormikContext } from 'formik';
import c from 'classnames';
import GenericFormElement from '../GenericFormElement';
import useAriaDescribedByField from '../../../hooks/useAriaDescribedByField';
const FormTextField = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    name,
    label,
    onBlur,
    onChange,
    className,
    optionalLabel,
    defaultValue,
    unit,
    unitAfter,
    verticalSpacing,
    visualValidation,
    description,
    isLiveValidationDisabled
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    submitCount
  } = useFormikContext();
  const {
    ariaDescribedBy
  } = useAriaDescribedByField({
    field,
    meta,
    description
  });
  const containerClassNames = c('input-container', {
    'input-with-unit': unit,
    'input-with-unit--before': !unitAfter && unit,
    'input-with-unit--after': unitAfter && unit
  });
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    name: name,
    label: label,
    meta: meta,
    helpers: helpers,
    className: className,
    defaultValue: defaultValue,
    visualValidation: visualValidation,
    containerClassName: containerClassNames,
    verticalSpacing: verticalSpacing,
    description: description,
    optionalLabel: optionalLabel,
    submitCount: submitCount,
    isLiveValidationDisabled: isLiveValidationDisabled
  }, unit && !unitAfter && /*#__PURE__*/React.createElement("div", {
    className: "unit icon-after icon-".concat(unit)
  }), /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    id: name,
    type: "text"
  }, props, field, {
    "aria-describedby": ariaDescribedBy,
    onBlur: e => {
      if (onBlur) onBlur(e);
      field.onBlur(e);
    },
    onChange: e => {
      if (onChange) onChange(e);
      field.onChange(e);
    }
  })), unit && unitAfter && /*#__PURE__*/React.createElement("div", {
    className: "unit icon-after icon-".concat(unit)
  }));
});
export default FormTextField;